namespace AgerLMS.LMS {
    export interface AddToCartRequest extends Serenity.ServiceRequest {
        ItemId?: number;
        ItemType?: string;
        PriceItemId?: string;
        Quantity?: number;
    }
}
